export default {"src":"/_next/static/media/qrcode.fc2570fe.svg","height":1000,"width":1000};